module.exports = __webpack_public_path__ + "static/media/icon-search.705862ff.svg";